import React from 'react';
import { useTranslation } from 'react-i18next';
import DetailToolBridgeModal from '@/pages/ipe/workbench/modals/DetailToolBridgeModal';
import GoodsStudioCreateModal from '@/pages/ipe/workbench/modals/GoodsStudioCreateModal';
import AiCopywritingTemplatePickerModal from '@/pages/ipe/workbench/modals/AiCopywritingTemplatePickerModal';
import ImageTemplatePickerModal from '@/pages/ipe/workbench/modals/ImageTemplatePickerModal';

/**
 * 快捷功能共用弹窗宿主：确认 → 建任务 → Toast 跳转功能页（逻辑在 useDetailQuickToolBridge）。
 * @param {{ bridge: ReturnType<typeof import('../hooks/useDetailQuickToolBridge').default>, copywritingSelectedCountFallback?: number }} props
 */
export default function DetailQuickToolBridgeModals({
  bridge,
  copywritingSelectedCountFallback = 0,
}) {
  const { t } = useTranslation('workbench');
  if (!bridge) return null;

  const {
    bridgeLaunch,
    bridgeConfirming,
    closeBridgeLaunch,
    setBridgeLaunchStudioParams,
    setBridgeLaunchImageTemplates,
    confirmBridgeLaunch,
    enablePodPicker,
    podPickerOpen,
    podTemplates,
    podSelectedTemplateIds,
    podTemplateGroup,
    setPodTemplateGroup,
    podCanAccessTeamTemplates,
    podPickerSources,
    closePodPicker,
    confirmPodPicker,
    togglePodTemplate,
    busy,
    goodsBridge,
    copywritingBridge,
    listingAutoRulePickModal,
  } = bridge;

  return (
    <>
      {listingAutoRulePickModal || null}
      <DetailToolBridgeModal
        open={Boolean(bridgeLaunch)}
        targetNavId={bridgeLaunch?.navId || ''}
        sources={bridgeLaunch?.sources || []}
        studioParams={bridgeLaunch?.studioParams || {}}
        imageTemplates={bridgeLaunch?.imageTemplates || []}
        onStudioParamsChange={setBridgeLaunchStudioParams}
        onImageTemplatesLoaded={setBridgeLaunchImageTemplates}
        confirming={bridgeConfirming}
        onClose={closeBridgeLaunch}
        onConfirm={confirmBridgeLaunch}
      />

      <GoodsStudioCreateModal
        isOpen={goodsBridge.goodsStudioModalOpen}
        onClose={goodsBridge.closeGoodsStudioCreate}
        onConfirm={goodsBridge.confirmGoodsStudioCreate}
        params={goodsBridge.goodsStudioParams}
        onParamsChange={goodsBridge.setGoodsStudioParams}
        sources={goodsBridge.goodsStudioSources}
        sourceCount={goodsBridge.goodsStudioSourceCount}
        confirming={goodsBridge.goodsStudioBusy}
        intent={goodsBridge.goodsStudioModalIntent}
      />

      <AiCopywritingTemplatePickerModal
        isOpen={copywritingBridge.copywritingModalOpen}
        onClose={copywritingBridge.closeAiCopywritingPicker}
        onConfirm={copywritingBridge.confirmAiCopywritingTemplate}
        presets={copywritingBridge.copywritingPresets}
        selectedId={copywritingBridge.copywritingSelectedPresetId}
        onSelectId={copywritingBridge.setCopywritingSelectedPresetId}
        sources={copywritingBridge.copywritingSources}
        selectedCount={copywritingBridge.copywritingSourceCount || copywritingSelectedCountFallback}
        confirming={copywritingBridge.copywritingBusy}
        canAccessTeamPresets={copywritingBridge.copywritingCanAccessTeamPresets}
        ownerNameByUserId={copywritingBridge.copywritingOwnerNameByUserId}
        initialScope={copywritingBridge.copywritingTemplateScope}
        intent={copywritingBridge.copywritingModalIntent}
        initialLanguage={copywritingBridge.copywritingInitialLanguage}
        initialMaxChars={copywritingBridge.copywritingInitialMaxChars}
        initialPrompt={copywritingBridge.copywritingInitialPrompt}
        onGoManage={copywritingBridge.goManageCopywritingTemplates}
      />

      {enablePodPicker ? (
        <ImageTemplatePickerModal
          isOpen={podPickerOpen}
          title={t('nav.podProductDesign.label')}
          confirming={busy}
          enableScopeTabs
          canAccessTeamTemplates={podCanAccessTeamTemplates}
          selectedSources={podPickerSources}
          onCancel={closePodPicker}
          onConfirm={confirmPodPicker}
          groups={[]}
          selectedGroup={podTemplateGroup}
          onGroupChange={setPodTemplateGroup}
          templates={podTemplates}
          selectedTemplateIds={podSelectedTemplateIds}
          onToggleTemplate={togglePodTemplate}
        />
      ) : null}
    </>
  );
}
